import { ReceiptInfo } from '../api/receiptAPI';

export const receiptMock: ReceiptInfo = {
    firstName: 'Kari',
    registeredFamilyMembers: [{ fullName: 'Ola Nordmann' }, { fullName: 'Baby Nordmann' }],
    duplicateFamilyMembers: [{ fullName: 'Kari Nordmann' }],
    failedFamilyMembers: [{ fullName: 'Storebror Nordmann' }, { fullName: 'Storesøster Nordmann' }],
};
